import React from "react"
import Utils from "../../utilities/Utils";
import { FormSectionElements } from "src/entities/formTemplateDataType";

interface Props {
    errorMsgList;
    isEng: boolean;
}

export class ErrorAlertsComponent extends React.Component<Props> {

    constructor(props: Props) {
        super(props);
    }

    generateHtmlString = () => {
        const basePath = window.location.pathname;
        const hash = window.location.hash; // "#/subpath/page"
        const fullPath = `${basePath}${hash}`;
        let errorMsgList = this.props.errorMsgList;

        if (errorMsgList == null || errorMsgList?.filter(p => p.Visible).length == 0) return null;

        let html = [];
      
        let errorMsgBulletPointHtml = [];

        errorMsgList.filter(p => p.Visible).forEach((field: FormSectionElements) => {
            const message = field.IsEmpty ? (this.props.isEng ? field.EmptyErrorMessage : field.EmptyErrorMessageFRA)
                : (this.props.isEng ? field.ErrorMessage : field.ErrorMessageFRA)
            if (message) {
                errorMsgBulletPointHtml.push(
                    <li key={"error_" + field.Datatype + "_" + field.Id}>
                        <a href={`${basePath}#${field.LoadBindName}`} style={{whiteSpace: 'pre-line'}}>{message}</a>
                        {/* <span style={{color: '#d81a21'}}>{message}</span> */}
                    </li>
                );
            }
        });

        if (errorMsgBulletPointHtml.length) {
            html.push(
                <div className="ontario-alert ontario-alert--error callout-max-width" role="alert" tabIndex={-1} id="error-container" >
                    <div className="ontario-alert__header">
                        <div className="ontario-alert__header-icon">
                            <svg className="ontario-icon" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="#cd0000" />
                                <path d="M11 17h2v-2h-2v2zm0-4h2V7h-2v6z" fill="#fff" />
                                <use href="#ontario-icon-alert-error"></use>
                            </svg>
                        </div>
                        <h2 className="ontario-alert__header-title ontario-h4">{this.props.isEng ? "There is a problem" : "Il y a un problème!"}</h2>
                    </div>
                    <div className="ontario-alert__body">
                        <p>{this.props.isEng ? "Errors were found on this page" : "Des erreurs ont été trouvées sur cette page"}</p>
                        <ul>
                            {errorMsgBulletPointHtml}
                        </ul>
                    </div>
                </div>
            );
        }
        return html;
    }


    render() {
        return (
            this.generateHtmlString()
        )
    }
}
